import React from 'react';

export default function NotFound ({title}){
  return (
      <div className="flex justify-center items-center h-full absolute w-full -mt-10">
        <h1>{title ?? 'Pagina niet gevonden'}</h1>
      </div>
  )
}
